import React, { useEffect, useState } from "react";
//import Plotly from 'plotly.js-dist';
import createPlotlyComponent from "react-plotly.js/factory";
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Plot = createPlotlyComponent(window.Plotly);

interface Props {
  passableKey:string,
  config: any,
  selectedLayerId: string | null,
  updateHistogramId: number,
  plotConfigs: any,
  updateId: number,
  dwFilters: any,
  setDwFilters: Function,
}

const HistogramTable = ({ passableKey, config, selectedLayerId, updateHistogramId, plotConfigs, updateId, dwFilters, setDwFilters }: Props) => {

  console.log("040223 config", config)
  const [summarizedData, setSummarizedData] = useState<any>(null);
  useEffect(() => {
      console.log("040223 passableKey", passableKey);
      console.log("040223 plotConfigs", plotConfigs);
      console.log("040223 config", config);
      console.log("040223 updateId", updateId);
      console.log("040223 updateHistogramId", updateHistogramId);
      console.log("040223 selectedLayerId", selectedLayerId);
      function sortData(data:any) {
        return data.sort((a:any, b:any) => {
          return b.cultivar.localeCompare(a.cultivar);
        });
      }
      const summarizeData = (data:any) => {
        const summary = new Map();
      
        data.forEach(([cultivar, status]:any) => {
          const key = `${cultivar}_${status}`;
          summary.set(key, (summary.get(key) || 0) + 1);
        });
      
        return Array.from(summary).map(([key, count]) => {
          const [cultivar, status] = key.split('_');
          return [cultivar, status, count];
        });
      };
      function transformData(data:any) {
        const cultivarStatusCounts = {};

        data.forEach(([cultivar, status, count]:any) => {
          if (!cultivarStatusCounts[cultivar]) {
            cultivarStatusCounts[cultivar] = {};
          }
          cultivarStatusCounts[cultivar][status] = count;
        });
      
        return Object.entries(cultivarStatusCounts).map(([cultivar, statuses]:any) => ({
          cultivar,
          ...statuses
        }));
      }
      
      setSummarizedData(sortData(transformData(summarizeData(config.status.data))));
    
  }, [plotConfigs, updateId, config, updateHistogramId, selectedLayerId]);
  
  useEffect(() => {
    console.log("A111723 summarizedData", summarizedData);
  }, [summarizedData]);

  return (
    summarizedData
    ? <>
      <div className="staus-table">
        <div className="-col-headers">
          <div className="-row-cell">Mature</div>
          <div className="-row-cell">Immature</div>
          <div className="-row-cell">Dead</div>
          <div className="-row-cell">Missing</div>
        </div>
        { summarizedData.map((item:any) => {
        //console.log("A111723 item", item);
        return(
          <div key={`col_${item.cultivar.replaceAll(" ", "_")}`} className="-col" style={{width:`calc((100% - 50px)/${summarizedData.length})`}}>
            <div key={`row_1_${item.cultivar.replaceAll(" ", "_")}`} className="-row-cell">{item.mature ? item.mature.toLocaleString() : "n/a"}</div>
            <div key={`row_2_${item.cultivar.replaceAll(" ", "_")}`} className="-row-cell">{item.immature ? item.immature.toLocaleString() : "n/a"}</div>
            <div key={`row_3_${item.cultivar.replaceAll(" ", "_")}`} className="-row-cell">{item.dead ? item.dead.toLocaleString() : "n/a"}</div>
            <div key={`row_4_${item.cultivar.replaceAll(" ", "_")}`} className="-row-cell">{item.missing ? item.missing.toLocaleString() : "n/a"}</div>
          </div>
        )
        })}
      </div>
    </>
    :<></>
  );
}


export default HistogramTable;